import React from "react";
import { Button } from "@kelp-dao/kernel-design-system";
import { IMAGES } from "@constants/images";
import BaseImage from "@components/BaseImage";

type DisconnectedProps = {
  onConnectWallet: () => void;
  title?: string;
  subtitle?: string;
  buttonText?: string;
};

const Disconnected: React.FC<DisconnectedProps> = ({
  onConnectWallet,
  title,
  subtitle,
  buttonText,
}) => {
  return (
    <div className="flex flex-col items-center justify-center w-full py-[80px] text-center">
      <BaseImage
        src={IMAGES.DASHBOARD.DISCONNECTED}
        alt="You're not connected yet"
        width={159}
        height={159}
        className="h-auto w-[159px]"
      />
      <div className="mt-6">
        <p className="text-xl md:text-2xl font-semibold text-text-primary">
          {title || `You're not connected yet.`}
        </p>
        <p className="mt-2 text-xs md:text-sm text-text-secondary max-w-xl">
          {subtitle || "Please link your wallet to access your rewards."}
        </p>
      </div>
      <Button
        variant="primary"
        onClick={onConnectWallet}
        className="mt-5 h-11 min-w-[92px] rounded-lg text-base md:text-lg font-medium"
      >
        {buttonText || "Connect wallet"}
      </Button>
    </div>
  );
};

export default Disconnected;
